import React from 'react';
import home from '@/assets/image/icon-home.png';
import styles from './index.less';
import { Breadcrumb } from 'antd';
import { Link } from 'dva/router';

export interface IBreadcrumbItem {
  title: string;
  link?: string;
}

interface IWazBreadcrumbProps {
  data: IBreadcrumbItem[];
}

const WazBreadcrumb: React.FC<IWazBreadcrumbProps> = ({ data }) => {
  return (
    <div className={styles.index}>
      <Breadcrumb separator="-" className={styles.breadcrumb}>
        <Breadcrumb.Item>
          <Link to='/app/home'>
            <img src={home} className={styles.iconHome} />首页
          </Link>
        </Breadcrumb.Item>
        {data.map(item => {
          if (item.link) {
            return (
              <Breadcrumb.Item key={item.title}>
                <Link to={item.link}>{item.title}</Link>
              </Breadcrumb.Item>
            )
          }
          return <Breadcrumb.Item key={item.title}>{item.title}</Breadcrumb.Item>
        })}

      </Breadcrumb>
    </div>
  );
};

export default WazBreadcrumb;